import { render } from "./journal-icon.vue.js?vue&type=template&id=22b167fe!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./journal-icon.vue?vue&type=template&id=22b167fe"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__